import React, { useRef, useEffect, useContext } from 'react';
// import useNebula from 'hooks/useNebula';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../AppContext';

const useStyles = makeStyles((theme) => ({
  viz: {
    height: 600,
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('xs')]: {
      //   height: 200,
    },
  },
}));

const GroupedBar = () => {
  const { nebula } = useContext(AppContext);

  // const nebula = useNebula();
  const elementRef = useRef();
  const vizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;

    vizRef.current = await nebula.render({
      type: 'barchart',
      element: elementRef.current,
      fields: [
        {
          qDef: {
            qFieldDefs: ['=$(vValueListDim)'],

            qSortCriterias: [{
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
            }],
          },
          qNullSuppression: true,
        },
        {
          // 2021
          qDef: {
            qLabel: '2021',
            qDef: `=If([#LANGUAGE] = 'French',
            If($(vValueListDim)='# de Salles de presse',
                209, // Count(distinct {<"Year - Comp All"={'2021'}>} [Name of media outlet completing the survey - Comp All])*-1,
                If($(vValueListDim)='# de Journalistes',
                    Sum({<"Year - Comp All"={'2021'}>} [Number of Employees - Comp All]),
                    If($(vValueListDim)='# d’hommes',
                        Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
                        If($(vValueListDim)='# de femmes',
                            Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
                            If($(vValueListDim)='# de non-binaires',
                                Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
                                If($(vValueListDim)='# de superviseurs',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A plein temps',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A temps partiel',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de stagiaires',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# d’indigènes',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# d’Asiatiques',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='# de Noirs',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de Latins',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Moyen-oriental',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Blancs',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='Race mixte',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='Inconnue',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
        
        ))))))))))))))))
        ),
        
        If($(vValueListDim)='# of Media Outlets',
            209,//Count(distinct {<"Year - Comp All"={'2021'}>} [Name of media outlet completing the survey - Comp All])*-1,
            
            If($(vValueListDim)='# of Journalist',
                Sum({<"Year - Comp All"={'2021'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Men',
                Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Women',
                Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Non-Binary',
                Sum({<"Year - Comp All"={'2021'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Supervisors',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Full-time',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Part-time',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Interns',
                Sum({<"Year - Comp All"={'2021'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Indigenous',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# of Asian',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='# of Black',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Latin',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# of Middle Eastern',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# of White',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='# of Mixed Race',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# of Unknown',
                Sum({<"Year - Comp All"={'2021'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
        
        )))))))))))))))))
        
    
        ) 
    `,
            qNumFormat: {
              qType: 'F',
              qnDec: 2,
              qUseThou: 0,
              qFmt: '####',
              qDec: '.',
              qThou: ',',
            },
          },

        },
        {
          // 2022
          qDef: {
            qLabel: '2022',
            qDef: `=If([#LANGUAGE] = 'French',
            If($(vValueListDim)='# de Salles de presse',
                242, // Count(distinct {<"Year - Comp All"={'2021'}>} [Name of media outlet completing the survey - Comp All])*-1,
                If($(vValueListDim)='# de Journalistes',
                    5012,
                    If($(vValueListDim)='# d’hommes',
                        Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
                        If($(vValueListDim)='# de femmes',
                            Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
                            If($(vValueListDim)='# de non-binaires',
                                Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
                                If($(vValueListDim)='# de superviseurs',
                Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A plein temps',
                Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A temps partiel',
                Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de stagiaires',
                Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# d’indigènes',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# d’Asiatiques',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='# de Noirs',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de Latins',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Moyen-oriental',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Blancs',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='Race mixte',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='Inconnue',
                Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
        
        ))))))))))))))))
        ),
        
      If($(vValueList)='# of Media Outlets',
      242,//Count(distinct {<"Year - Comp All"={'2022'}>} [Name of media outlet completing the survey - Comp All]),
        
      If($(vValueList)='# of Journalist',
        5012,//Sum({<"Year - Comp All"={'2022'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Men',
        Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Women',
        Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Non-Binary',
        Sum({<"Year - Comp All"={'2022'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
       
      If($(vValueList)='# of Supervisors',
        Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Full-time',
        Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Part-time',
        Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Interns',
        Sum({<"Year - Comp All"={'2022'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Indigenous',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of Asian',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
           
        If($(vValueList)='# of Black',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Latin',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of Middle Eastern',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of White',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
           
        If($(vValueList)='# of Mixed Race',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Unknown',
        Sum({<"Year - Comp All"={'2022'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
    
    )))))))))))))))))
    
        
    
        ) 
    `,
            qNumFormat: {
              qType: 'F',
              qnDec: 2,
              qUseThou: 0,
              qFmt: '####',
              qDec: '.',
              qThou: ',',
            },
          },

        },
        {
          // 2023
          qDef: {
            qLabel: '2023',
            qDef: `=If([#LANGUAGE] = 'French',
            If($(vValueListDim)='# de Salles de presse',
                285, // Count(distinct {<"Year - Comp All"={'2021'}>} [Name of media outlet completing the survey - Comp All])*-1,
                If($(vValueListDim)='# de Journalistes',
                    6035,
                    If($(vValueListDim)='# d’hommes',
                        Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
                        If($(vValueListDim)='# de femmes',
                            Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
                            If($(vValueListDim)='# de non-binaires',
                                Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
                                If($(vValueListDim)='# de superviseurs',
                Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A plein temps',
                Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='A temps partiel',
                Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de stagiaires',
                Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# d’indigènes',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# d’Asiatiques',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='# de Noirs',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='# de Latins',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Moyen-oriental',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
            
            If($(vValueListDim)='# de Blancs',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
               
            If($(vValueListDim)='Race mixte',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
                
            If($(vValueListDim)='Inconnue',
                Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
        
        ))))))))))))))))
        ),
        
    If($(vValueList)='# of Media Outlets',
      285,
        
      If($(vValueList)='# of Journalist',
        6035,
            
        If($(vValueList)='# of Men',
        Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Men'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Women',
        Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Women'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Non-Binary',
        Sum({<"Year - Comp All"={'2023'}, "Gender - Comp All"={'Non-Binary'}>} [Number of Employees - Comp All]),
       
      If($(vValueList)='# of Supervisors',
        Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Supervisor'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Full-time',
        Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Full-time'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Part-time',
        Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Part-time'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Interns',
        Sum({<"Year - Comp All"={'2023'}, "Job Role - Comp All"={'Interns'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Indigenous',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Indigenous'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of Asian',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Asian'}>} [Number of Employees - Comp All]),
           
        If($(vValueList)='# of Black',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Black'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Latin',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Latin'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of Middle Eastern',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Middle Eastern'}>} [Number of Employees - Comp All]),
        
        If($(vValueList)='# of White',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'White'}>} [Number of Employees - Comp All]),
           
        If($(vValueList)='# of Mixed Race',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Mixed Race'}>} [Number of Employees - Comp All]),
            
        If($(vValueList)='# of Unknown',
        Sum({<"Year - Comp All"={'2023'}, "Race - Comp All"={'Unknown'}>} [Number of Employees - Comp All])
    
    )))))))))))))))))
    
        )     

            `,
            qNumFormat: {
              qType: 'F',
              qnDec: 2,
              qUseThou: 0,
              qFmt: '####',
              qDec: '.',
              qThou: ',',
            },
          },

        },
      ],
      // overrides default properties
      properties: {
        barGrouping: {
          grouping: 'grouped',
        },
        dataPoint: {
          showLabels: true,
          showSegmentLabels: false,
          showTotalLabels: false,
        },
        dimensionAxis: {
          dock: 'near',
          showLabels: true,
          showTitle: false,
        },
        measureAxis: {
          dock: 'near',
          showLabels: true,
          showTitle: false,
        },
        legend: {
          dock: 'right',
          showTitle: false,
          show: true,
        },
        orientation: 'horizontal',
      },
    });
  }, [nebula]);

  const classes = useStyles();

  return (
    <Box className={classes.groupedBarChart}>
      <div id="groupedBarViz" className={classes.viz} ref={elementRef} />
    </Box>
  );
};

export default GroupedBar;
